module.exports = __webpack_public_path__ + "static/media/addIcon.133b2091.svg";